import type { IconData } from '@stacksjs/iconify-core'

export const dataTransferUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 16h480v32H16zm100.687 196.687l22.626 22.626L232 142.627V496h32V142.627l92.687 92.686l22.626-22.626L248 81.373z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default dataTransferUp
